import {
  SHOW_LITERACY_MODAL,
  HIDE_LITERACY_MODAL,
  SET_LITERACY_RESULT,
  OFFLINE_SPINNER_OFF,
  OFFLINE_SPINNER_ON,
  RESET_GLOBL_STATE,
  GLOBAL_ERR,
  CLEAR_GLOBAL_ERR,
} from 'actions/actionTypes';
import { IAppStateState } from 'types';

export interface ActionType {
  type:
    | 'SHOW_LITERACY_MODAL'
    | 'HIDE_LITERACY_MODAL'
    | 'SET_LITERACY_RESULT'
    | 'OFFLINE_SPINNER_ON'
    | 'GLOBAL_ERR'
    | 'RESET_GLOBL_STATE'
    | 'OFFLINE_SPINNER_OFF'
    | 'CLEAR_GLOBAL_ERR';

  payload?: {
    result?: boolean;
    activeUnit?: number;
    globalError?: string;
  };
}

const initialState: IAppStateState = {
  literacyModalActive: false,
  literacyModalResult: null,
  showStatusOfflineSpinner: false,
};

const appState = (state = initialState, action: ActionType): IAppStateState => {
  switch (action.type) {
    case SHOW_LITERACY_MODAL:
      return {
        ...state,
        literacyModalActive: true,
        // clear prev result
        literacyModalResult: null,
      };
    case HIDE_LITERACY_MODAL:
      return {
        ...state,
        literacyModalActive: false,
        literacyModalResult: null,
      };
    case SET_LITERACY_RESULT:
      return {
        ...state,
        literacyModalResult: action.payload?.result || null,
      };
    case OFFLINE_SPINNER_ON:
      return {
        ...state,
        showStatusOfflineSpinner: true,
        offlineSpinnerUnitId: action.payload?.activeUnit,
      };

    case OFFLINE_SPINNER_OFF:
      return {
        ...state,
        showStatusOfflineSpinner: false,
        offlineSpinnerUnitId: undefined,
      };
    case GLOBAL_ERR:
      return {
        ...state,
        globalError: action.payload?.globalError,
      };
    case CLEAR_GLOBAL_ERR:
      return {
        ...state,
        globalError: undefined,
      };
    case RESET_GLOBL_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default appState;
